var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { AuthUserDetailsComponent } from './authentication/auth-user-details/auth-user-details.component';
import { ModalService, ModalcloseReason } from 'hsg';
import { AuthUserOtpComponent } from './authentication/auth-user-otp/auth-user-otp.component';
import { AuthIssueDateComponent } from './authentication/auth-issue-date/auth-issue-date.component';
import { AuthAuthenticateMethodComponent } from './authentication/auth-authenticate-method/auth-authenticate-method.component';
import { AuthChangePasswordComponent } from './authentication/auth-change-password/auth-change-password.component';
import { AuthCreditCardComponent } from './authentication/auth-credit-card/auth-credit-card.component';
import { AuthCustomerServiceComponent } from './authentication/auth-customer-service/auth-customer-service.component';
import { AuthEndProcessComponent } from './authentication/auth-end-process/auth-end-process.component';
import { AuthPermanentPasswordComponent } from './authentication/auth-permanent-password/auth-permanent-password.component';
import { AuthUserActivationComponent } from './authentication/auth-user-activation/auth-user-activation.component';
import { AuthValidateDetailsComponent } from './authentication/auth-validate-details/auth-validate-details.component';
import { AuthOpenCallsComponent } from './authentication/auth-open-calls/auth-open-calls.component';
import { ServerResponse } from './authentication/constants/server-response.model';
import { EndProcessMessage } from './authentication/constants/end-process-message.model';
import { AuthUserService } from './authentication/auth-user.service';
import { AuthSuccessRegistrationComponent } from './authentication/auth-success-registration/auth-success-registration.component';
import { AuthLoaderComponent } from './authentication/auth-loader/auth-loader.component';
import { environment } from '../environments/environment';
import { AuthStrictIdChoiceComponent } from './authentication/auth-strict-id-choice/auth-strict-id-choice.component';
var AppComponent = /** @class */ (function () {
    function AppComponent(modalService, authUserService) {
        this.modalService = modalService;
        this.authUserService = authUserService;
        this._redirect = "/personal-info";
        this.isProdMode = environment.production;
        this.config = {
            disableClose: false,
            disabeCloseByX: false,
            disableCloseByBg: true,
            showConfirm: true,
        };
        if (this.isShowLogin) {
            var source = this.getUrlParameter("Source");
            if (source) {
                this._redirect = source;
            }
            sessionStorage.setItem("loginOriginAction", "Personal Info Page");
            this.modalService.open(AuthUserDetailsComponent, this.config);
        }
    }
    AppComponent.prototype.onMessage = function (event) {
        if (event.data.id == "CustomerRouting") {
            this._redirect = event.data.source;
            this.modalService.open(AuthUserDetailsComponent, this.config);
        }
        //console.log("angular-received-postmessage", event.data);
        if (event.data.Details) {
            event.data["data"] = event.data["Details"];
            delete event.data["Details"];
            this.handleServerResponse(event.data);
        }
    };
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        sessionStorage.removeItem("currentWindow");
        this.modalService.subscribeToClose(function (res) {
            try {
                //console.log("server-response", res);
                if (res.closeReason == ModalcloseReason.action) {
                    _this.handleServerResponse(res);
                }
                else if (res.closeReason == ModalcloseReason.confirm) {
                    var currentWindow_1 = sessionStorage.getItem("currentWindow");
                    var endProccessElasticCode_1 = sessionStorage.getItem("elasticCode");
                    //this.modalService.data["CurrentProcess"] this caused  the code to "fly"
                    if (window["dataLayer"] !== undefined && _this.modalService.data != undefined) {
                        window["dataLayer"].push({
                            GA_EventCategory: "Login and Registrarion",
                            GA_EventAction: "Login process stopped - By User",
                            GA_EventLabel: "Screen Name = " + currentWindow_1 + " - " + sessionStorage.getItem("loginOriginAction"),
                            event: 'GTM event To GA'
                        });
                    }
                    //report end login proccess to action log
                    _this.authUserService.sendAuthData("EndProcess", { EndProcessScreen: currentWindow_1 })
                        .subscribe(function () { return console.log("Reporting to server-EndProcess", currentWindow_1); });
                    //report end login proccess  elastic log 
                    if (endProccessElasticCode_1) {
                        _this.authUserService.sendAuthData("ElasticLogger", { elasticCode: endProccessElasticCode_1 })
                            .subscribe(function (res) { return console.log("sent elasticLog code:" + endProccessElasticCode_1 + " - close window", res); });
                    }
                }
            }
            catch (error) {
                console.log("subsciber error");
            }
        });
    };
    AppComponent.prototype.handleServerResponse = function (res) {
        //save current user data
        if (res.data.ProcessSuccess == ServerResponse.USER_LOGGED_IN_SUCCESS && res.data.current) {
            sessionStorage.setItem("CurrentUserDetails", JSON.stringify(res.data.current));
        }
        if (res.data.ProcessError == ServerResponse.VALIDATE_DETAILS) {
            this.modalService.open(AuthValidateDetailsComponent, __assign({}, this.config, { data: res.data }));
        }
        else if (res.data.ProcessError == ServerResponse.PASSWORD_USER_LOCKED) {
            this.modalService.open(AuthEndProcessComponent, __assign({}, this.config, { data: EndProcessMessage.PASSWORD_USER_LOCKED }));
        }
        else if (res.data.ProcessSuccess == ServerResponse.OTP_SENT) {
            this.modalService.open(AuthUserOtpComponent, __assign({}, this.config, { data: res.data }));
        }
        else if (res.data.ProcessSuccess == ServerResponse.REGISTRATION_SUCCESS) {
            this.modalService.open(AuthSuccessRegistrationComponent, __assign({}, this.config, { data: res.data }));
        }
        else if (res.data.ProcessSuccess == ServerResponse.IDENTIFICATION_TYPE) {
            this.modalService.open(AuthAuthenticateMethodComponent, this.config);
        }
        else if (res.data.ProcessSuccess == ServerResponse.PERMANENT_PASSWORD) {
            this.modalService.open(AuthPermanentPasswordComponent, this.config);
        }
        else if (res.data.ProcessSuccess == ServerResponse.CHANGE_PASSWORD) {
            this.modalService.open(AuthChangePasswordComponent, this.config);
        }
        else if (res.data.showDecleration == ServerResponse.SHOW_DECLERATION) {
            this.modalService.open(AuthUserActivationComponent, __assign({}, this.config, { data: res.data }));
        }
        else if (res.data.ProcessError == ServerResponse.ALREADY_EXIST) {
            this.modalService.open(AuthEndProcessComponent, __assign({}, this.config, { data: __assign({}, EndProcessMessage.ALREADY_EXIST, res.data, { showContactCall: false }) }));
        }
        else if (res.data.ProcessError == ServerResponse.USER_IS_BLOCKED) {
            this.modalService.open(AuthEndProcessComponent, __assign({}, this.config, { data: __assign({}, EndProcessMessage.USER_BLOCKED, { showContactCall: true }) }));
        }
        else if (res.data.ProcessSuccess == ServerResponse.NEED_DETAILS) {
            this.modalService.open(AuthCustomerServiceComponent, __assign({}, this.config, { data: res.data }));
        }
        else if (res.data.ProcessSuccess == ServerResponse.REQUEST_CEATED) {
            this.modalService.open(AuthEndProcessComponent, __assign({}, this.config, { data: __assign({}, res.data, EndProcessMessage.CUSTOMER_SERVICE, { showContactCall: false }) }));
        }
        else if (res.data.TechnicalError) {
            this.modalService.open(AuthEndProcessComponent, __assign({}, this.config, { data: EndProcessMessage.TECHNICAL_ERROR }));
        }
        else if (res.data.ProcessSuccess == ServerResponse.ISSUE_DATE) {
            this.modalService.open(AuthIssueDateComponent, __assign({}, this.config, { data: res.data }));
        }
        else if (res.data.ProcessSuccess == ServerResponse.FULL_STRICT || res.data.ProcessSuccess == ServerResponse.CREDIT_CARD) {
            this.modalService.open(AuthCreditCardComponent, __assign({}, this.config, { data: res.data }));
        }
        else if (res.data.ProcessSuccess == ServerResponse.CHOICE_STRICT) {
            this.modalService.open(AuthStrictIdChoiceComponent, __assign({}, this.config, { data: res.data }));
        }
        else if (res.data.ClientHasOpenCalls == ServerResponse.HAS_OPEN_CALLS) {
            this.modalService.open(AuthOpenCallsComponent, __assign({}, this.config, { disabeCloseByX: true }));
        }
        else if (res.data.ClientHasOpenCalls == ServerResponse.HAS_NOT_OPEN_CALLS) {
            this.modalService.open(AuthLoaderComponent, null);
            window.location.href = this._redirect;
        }
        else if (res.data.redirect == ServerResponse.REDIRECT) {
            this.modalService.open(AuthLoaderComponent, null);
            window.location.href = this._redirect;
        }
        else {
            this.modalService.open(AuthEndProcessComponent, __assign({}, this.config, { data: EndProcessMessage.TECHNICAL_ERROR }));
        }
    };
    Object.defineProperty(AppComponent.prototype, "isShowLogin", {
        get: function () {
            return window.location.search.indexOf("isshowlogin=true") != -1;
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.getUrlParameter = function (name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
    ;
    AppComponent.prototype.openLoginModal = function () {
        this.modalService.open(AuthUserDetailsComponent, this.config);
    };
    AppComponent.prototype.openIssueDateModal = function () {
        this.modalService.open(AuthIssueDateComponent, __assign({}, this.config, { data: { CurrentProcess: 2 } }));
    };
    AppComponent.prototype.openAuthMethodModal = function () {
        this.modalService.open(AuthAuthenticateMethodComponent, this.config);
    };
    AppComponent.prototype.openChangePasswordModal = function () {
        this.modalService.open(AuthChangePasswordComponent, this.config);
    };
    AppComponent.prototype.openCreditCardModal = function () {
        this.modalService.open(AuthCreditCardComponent, this.config);
    };
    AppComponent.prototype.openCustomerServiceModal = function () {
        this.modalService.open(AuthCustomerServiceComponent, __assign({}, this.config, { data: { CustomerServiceReason: '99' } }));
    };
    AppComponent.prototype.openEndprocessModal = function () {
        this.modalService.open(AuthEndProcessComponent, __assign({}, this.config, { data: __assign({}, EndProcessMessage.CUSTOMER_SERVICE, { showContactCall: false }) }));
    };
    AppComponent.prototype.openPermanentpasswordeModal = function () {
        this.modalService.open(AuthPermanentPasswordComponent, this.config);
    };
    AppComponent.prototype.openActivationModal = function () {
        this.modalService.open(AuthUserActivationComponent, __assign({}, this.config, { data: { CurrentProcess: 'openActivationModal' } }));
    };
    AppComponent.prototype.openValidateDetailsModal = function () {
        this.modalService.open(AuthValidateDetailsComponent, __assign({}, this.config, { data: { UserId: 'dddd', FullPhone: '2323232', DetailsValidationCount: '1' } }));
    };
    AppComponent.prototype.openOtpModal = function () {
        sessionStorage.setItem("loginOriginAction", "openOtpModal");
        this.modalService.open(AuthUserOtpComponent, __assign({}, this.config, { data: { OTPCheckCount: "1" } }));
    };
    AppComponent.prototype.closeOpenCallsModal = function () {
        this.modalService.open(AuthOpenCallsComponent, __assign({}, this.config, { disabeCloseByX: true }));
    };
    AppComponent.prototype.openSuccessModal = function () {
        this.modalService.open(AuthSuccessRegistrationComponent, __assign({}, this.config, { data: { a: 1 } }));
    };
    AppComponent.prototype.openLoaderModal = function () {
        this.modalService.open(AuthLoaderComponent, null);
        window.location.href = "http://google.com";
    };
    AppComponent.prototype.openStrictIdChoice = function () {
        this.modalService.open(AuthStrictIdChoiceComponent, this.config);
    };
    return AppComponent;
}());
export { AppComponent };
